import { ICubeSchemaMapper } from '../cube-schema-mapper.interface';

export interface IScoreTimeSeriesMapper extends ICubeSchemaMapper {}
